import { SKIP_LOGOUT_REDIRECT_ONCE_KEY } from "~/utils/oauth-logout-redirect";

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) return;

  const companionOAuthCallbackRedirectPath =
    getCompanionOAuthCallbackRedirectPath({
      path: to.path,
      query: to.query,
      isCompanionOAuthRedirectEnabled: useIsCompanionOAuthRedirectEnabled(
        to.path
      ),
    });

  if (companionOAuthCallbackRedirectPath != undefined) {
    console.info("[companion-oauth] Routing OAuth callback query to callback page", {
      from: to.path,
      to: companionOAuthCallbackRedirectPath,
      hasCode: typeof to.query.code === "string",
      hasState: typeof to.query.state === "string",
    });

    return navigateTo({
      path: companionOAuthCallbackRedirectPath,
      query: to.query,
      replace: true,
    });
  }

  const user = await useAuthUser().getUser();

  if (!user) {
    if (useIsCompanionOAuthRedirectEnabled(to.path)) {
      return (window.location.href =
        useRuntimeConfig().public.oauthClient.oauthAuthUrl);
    } else if (
      window.location.hostname.startsWith("demo") ||
      window.location.hostname.startsWith("demos")
    ) {
      return navigateTo({
        path: "/auth/demo-login",
        replace: true,
      });
    } else {
      return navigateTo({
        path: "/auth/login",
        // This allos me to store the path the user was trying to access so that once they log in, I can redirect them back to where they were trying to access
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }

  const oauthClient = useRuntimeConfig().public.oauthClient;
  const shouldValidateCompanionOAuthSession =
    useIsCompanionOAuthRedirectEnabled(to.path) &&
    usePseudoLogin().isPseudoLogin !== true;

  if (shouldValidateCompanionOAuthSession) {
    try {
      const apiHeaders = await useApiHeaders();
      await $fetch("/api/companion/licenses", {
        headers: apiHeaders,
      });
    } catch (error) {
      if (
        isCompanionOAuthReauthenticationRequired(error) &&
        oauthClient.enableRedirect === true &&
        oauthClient.oauthAuthUrl
      ) {
        sessionStorage.setItem(SKIP_LOGOUT_REDIRECT_ONCE_KEY, "true");
        await useAppUserDataStore().logout();
        window.location.replace(oauthClient.oauthAuthUrl);
        return abortNavigation();
      }

      throw error;
    }
  }

  useInitializeStartupTasks();

  const idTokenExpirationTimeCookie = useCookie("authTokenExpirationTime", {
    secure: true,
  });

  if (idTokenExpirationTimeCookie.value != undefined) {
    const expirationTime = new Date(idTokenExpirationTimeCookie.value);

    if (expirationTime.getTime() > new Date().getTime()) {
      return;
    }
  }

  useCurrentUser()
    .value?.getIdTokenResult(true)
    .then(async (claims) => {
      const expirationTime = claims.expirationTime;
      const idToken = await useCurrentUser().value?.getIdToken();

      const idTokenCookie = useCookie("authToken", {
        secure: true,
      });

      idTokenCookie.value = idToken;

      idTokenExpirationTimeCookie.value = expirationTime;
    });
});
